import React from "react";
import classNames from "classnames";

interface ButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  label?: string;
  buttonClassName?: string;
  textClassName?: string;
}
const Button: React.FC<ButtonProps> = ({
  children,
  label,
  buttonClassName,
  textClassName,
  onClick,
}) => {
  return (
    <button
      className={classNames(
        "py-[14px]  w-[100%] border border-auctionStroke",
        buttonClassName
      )}
      onClick={onClick}
    >
      <p className={classNames("text-[23px]", textClassName)}> {label}</p>
      {children}
    </button>
  );
};

export default Button;
